import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  closeMessageBox,
  openMessageBox,
  sendMessage,
} from './../../jsCore/store/messageUser/MessageUser.actions'
import { MessageBox } from './MessageBox.container'
import { get as getFromPdo } from './../../jsCore/application/pageDataObject'
import { t } from './../../jsCore/providers/i18nProvider/i18nProvider'

class MessageUserContainerComponent extends Component {
  handleMessage = msg => this.props.sendMessage(msg, this.getToUserId())

  getToUserId = () => getFromPdo('page.user_id')

  render() {
    const { isMessageBoxOpen: isOpen, closeMessageBox: close } = this.props
    const BLOCK_NAME = 'private-message'

    return (
      <div className={BLOCK_NAME}>
        <button className={`${BLOCK_NAME}__open`} onClick={this.props.openMessageBox}>
          {t('common.message')}
        </button>
        <MessageBox isOpen={isOpen} close={close} handleMessage={this.handleMessage} />
      </div>
    )
  }
}

export const MessageUserContainer = ({ componentName, stateKey }) => {
  const mapStateToProps = state => state[stateKey]
  const mapDispatchToProps = { closeMessageBox, openMessageBox, sendMessage }

  return {
    name: componentName,
    stateKey,
    component: connect(mapStateToProps, mapDispatchToProps)(MessageUserContainerComponent),
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/message_user/MessageUser.container.js